export default (getStore) => {
  const pagingData = getStore().Global.pagingData;

  return (pagingData.page - 1) * pagingData.rowsPerPage;
};
